module.exports = __webpack_public_path__ + "img/bg5.22e53e71.png";